// extracted by mini-css-extract-plugin
module.exports = {"inquiry":"Inquiry-module__inquiry___1kVZ8","faqLink":"Inquiry-module__faqLink___3G6dT"};